import { f7, useStore } from 'framework7-react';
import { FC } from 'react';
import { RegisterNewMemberStep1 } from './RegisterNewMemberStep1/RegisterNewMemberStep1';
import { RegisterNewMemberStep2 } from './RegisterNewMemberStep2/RegisterNewMemberStep2';
import { RegisterNewMemberStep4 } from './RegisterNewMemberStep4/RegisterNewMemberStep4';
import style from './RegisterNewMemberStyle.module.css';
import { RegisterQRPageTemplate } from '@/components/uiParts/Template/RegisterQRPageTemplate/RegisterQRPageTemplate';
import { RegisterUserDataType } from '@/config/initialState';
import { store } from '@/config/store';
import { mobileAuthSelectedProcess } from '@/consts/auth';
import { useMobileAuth } from '@/hooks/api/auth/useMobileAuth';
import { MobileAuthApiParams } from '@/types/api/authApi';
import { buildRegisterQrPath } from '@/utils/registerQr';
import { storeDispatch } from '@/utils/store';
import './RegisterNewMemberStyle.scss';

export const RegisterNewMember: FC = () => {
  const registerUserData = useStore(
    store,
    'getRegisterUser',
  ) as RegisterUserDataType;
  const { currentStep, sourcePage, startStep } = registerUserData;
  const { authenticateMobile } = useMobileAuth();

  const isBackToSourcePage = sourcePage && currentStep === startStep;

  const handleBack = () => {
    if (isBackToSourcePage) {
      f7.view.main.router.navigate(sourcePage, { reloadAll: true });
      return;
    }
    if (currentStep > 1) {
      storeDispatch('setRegisterUser', 'registerUser', {
        ...registerUserData,
        currentStep: currentStep - 1,
      });
      return;
    }
    f7.view.main.router.navigate(
      buildRegisterQrPath(registerUserData.affiliate_id, registerUserData.sig),
      {
        transition: 'push-reverse',
      },
    );
  };

  const handleSkipStep4 = async () => {
    if (isBackToSourcePage) {
      handleBack();
      return;
    }
    // 会員登録後のSMS認証コードを送信
    const mobileAuthParams: MobileAuthApiParams = {
      phone_no:
        registerUserData.step1.tel1 +
        '-' +
        registerUserData.step1.tel2 +
        '-' +
        registerUserData.step1.tel3,
      selected_process: mobileAuthSelectedProcess.register,
      m_customer_id: registerUserData.m_customer_id,
      m_affiliate_id: registerUserData.affiliate_id
        ? String(registerUserData.affiliate_id)
        : undefined,
    };
    await authenticateMobile(mobileAuthParams);
  };

  return (
    <RegisterQRPageTemplate
      title={
        currentStep === 2
          ? '入力内容の確認'
          : currentStep === 3
          ? '車両登録'
          : '新規会員登録'
      }
      pageName="RegisterNewMember"
      showNavBack={true}
      handleClickBack={handleBack}
    >
      <div
        className={`${style['page']} ${
          currentStep === 1 ? style['white-page'] : ''
        }`}
      >
        {[1, 2].includes(currentStep) && (
          <div className={style['content']}>
            {currentStep === 1 && <RegisterNewMemberStep1 />}

            {currentStep === 2 && <RegisterNewMemberStep2 />}
          </div>
        )}

        {currentStep === 3 && (
          <RegisterNewMemberStep4
            hanldeCancel={handleSkipStep4}
            showSkip={!isBackToSourcePage}
          />
        )}
      </div>
    </RegisterQRPageTemplate>
  );
};
